import React from 'react';

export const ZoomIn = () => (
    <>
        <circle cx='10' cy='10' r='7' />
        <line x1='7' y1='10' x2='13' y2='10' />
        <line x1='10' y1='7' x2='10' y2='13' />
        <line x1='21' y1='21' x2='15' y2='15' />
    </>
);